import { InAppContentDefinition, MESSAGE_FORMAT } from 'modules/graphql/types';
import styled from 'styled-components';
import { FormField } from 'ui/formField';
import { BasicOption, BasicSelect, SelectValueDisplay } from 'ui/selects';
import { ValueDisplay } from 'ui/selects/SelectValueDisplay.styles';
import { pxToRem } from 'utils/convert';
import { SettingsReadOnlyText } from '../../common/EditorContentContainer.styled';
import { getIsEditMode } from '../../common/utils';
import { useEditableFieldsContext } from '../../context/EditableFieldsContext';
import { useQueryParamContext } from '../../context/QueryParamContext';
import { SELECTION_OPTIONS, SETTINGS_DISPLAY_CONTENT } from '../constants';

const StyledBasicSelect = styled(BasicSelect)`
  width: 100%;

  ${ValueDisplay} {
    width: 0;
    flex: 1 1 auto;
  }
`;

const StyledTrigger = styled(SelectValueDisplay)`
  > div {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: ${pxToRem(355)};
  }
`;

export const MessageFormat = () => {
  const { view } = useQueryParamContext();
  const { isEditMode, liveTemplate, setCurrentMediumField } = useEditableFieldsContext();
  const isEditModeVisible = getIsEditMode(view, isEditMode);
  const inAppMediumData = (liveTemplate?.mediumData || {}) as InAppContentDefinition;
  const messageFormat = inAppMediumData.messageFormat as MESSAGE_FORMAT;

  const onSetContentSelection = (value: MESSAGE_FORMAT) => {
    setCurrentMediumField('messageFormat', value);
  };

  return (
    <FormField
      isHorizontalLayout
      labelText={SETTINGS_DISPLAY_CONTENT.messageFormat.labelText}
      helpText={isEditModeVisible ? SETTINGS_DISPLAY_CONTENT.messageFormat.helpText : null}
    >
      {isEditModeVisible ? (
        <StyledBasicSelect
          id="contentSelection"
          defaultValues={[messageFormat]}
          isFullWidth
          Option={BasicOption}
          options={SELECTION_OPTIONS}
          onSelect={([newSelection]) => onSetContentSelection(newSelection as MESSAGE_FORMAT)}
          Trigger={StyledTrigger}
        />
      ) : (
        <SettingsReadOnlyText data-test="msg-format-ro">{messageFormat || ''}</SettingsReadOnlyText>
      )}
    </FormField>
  );
};
